// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from "@hey-api/client-next";
import type {
  HealthControllerGetReadinessData,
  HealthControllerGetReadinessResponse,
  HealthControllerGetLivenessData,
  HealthControllerGetLivenessResponse,
  HealthControllerGetCoffeeData,
  HealthControllerGetCoffeeError,
  HealthControllerGetUnhandledErrorData,
  HealthControllerGetUnhandledErrorError,
  AssignmentControllerGetGroupAssignmentsData,
  AssignmentControllerGetGroupAssignmentsResponse,
  AssignmentControllerGetUserAssignmentsData,
  AssignmentControllerGetUserAssignmentsResponse,
  AssignmentControllerUnassignUsersFromKitData,
  AssignmentControllerGetKitAssignmentsData,
  AssignmentControllerGetKitAssignmentsResponse,
  AssignmentControllerAssignUsersToKitData,
  AssignmentControllerAssignUsersToKitResponse,
  AssignmentControllerReassignKitData,
  AssignmentControllerReassignKitResponse,
  AuthControllerGetAuthDetailsData,
  AuthControllerGetAuthDetailsResponse,
  ChatLibraryFileControllerDetachFileData,
  ChatLibraryFileControllerDetachFileResponse,
  ChatLibraryFileControllerAttachFileData,
  ChatLibraryFileControllerAttachFileResponse,
  GroupKitChatControllerGetChatsData,
  GroupKitChatControllerGetChatsResponse,
  GroupKitChatControllerCreateChatData,
  GroupKitChatControllerCreateChatResponse,
  GroupKitChatControllerDeleteChatData,
  GroupKitChatControllerDeleteChatResponse,
  GroupKitChatControllerGetChatData,
  GroupKitChatControllerGetChatResponse,
  GroupKitChatControllerUpdateChatData,
  GroupKitChatControllerUpdateChatResponse,
  GroupKitChatControllerGetMessagesData,
  GroupKitChatControllerGetMessagesResponse,
  GroupKitChatControllerDeleteMessageData,
  GroupKitChatControllerDeleteMessageResponse,
  GroupConnectorControllerListConnectorsData,
  GroupConnectorControllerListConnectorsResponse,
  GroupConnectorControllerDeleteConnectorData,
  GroupConnectorControllerDeleteConnectorResponse,
  GroupConnectorControllerUpdateConnectorData,
  GroupConnectorControllerUpdateConnectorResponse,
  GroupConnectorControllerCreateSessionTokenData,
  GroupConnectorControllerCreateSessionTokenResponse,
  GroupConnectorControllerActivateConnectorData,
  GroupConnectorControllerActivateConnectorResponse,
  GroupMeetingControllerListMeetingsData,
  GroupMeetingControllerListMeetingsResponse,
  GroupMeetingControllerGetMeetingPreviewData,
  GroupMeetingControllerGetMeetingPreviewResponse,
  ExternalConnectionControllerCreateSessionTokenData,
  ExternalConnectionControllerCreateSessionTokenResponse,
  ExternalConnectionControllerCreatePendingConnectionData,
  ExternalConnectionControllerCreatePendingConnectionResponse,
  ExternalConnectionControllerActivateConnectionData,
  ExternalConnectionControllerActivateConnectionResponse,
  ExternalConnectionControllerGetGroupConnectionsData,
  ExternalConnectionControllerGetGroupConnectionsResponse,
  ExternalConnectionControllerGetUserConnectionsData,
  ExternalConnectionControllerGetUserConnectionsResponse,
  ExternalConnectionControllerListSharePointSitesData,
  ExternalConnectionControllerListSharePointSitesResponse,
  ExternalConnectionControllerListSharePointDrivesData,
  ExternalConnectionControllerListSharePointDrivesResponse,
  ExternalConnectionControllerGetSharePointMyDriveData,
  ExternalConnectionControllerGetSharePointMyDriveResponse,
  ExternalConnectionControllerGetSharePointDriveRootData,
  ExternalConnectionControllerGetSharePointDriveRootResponse,
  ExternalConnectionControllerDeleteConnectionData,
  ExternalConnectionControllerDeleteConnectionResponse,
  ExternalConnectionControllerGetConnectionData,
  ExternalConnectionControllerGetConnectionResponse,
  ExternalConnectionControllerTriggerSyncData,
  ExternalConnectionControllerTriggerSyncResponse,
  CustomPromptControllerGetAllData,
  CustomPromptControllerGetAllResponse,
  CustomPromptControllerCreateData,
  CustomPromptControllerCreateResponse,
  CustomPromptControllerDeleteData,
  CustomPromptControllerGetOneData,
  CustomPromptControllerGetOneResponse,
  CustomPromptControllerPatchData,
  CustomPromptControllerPatchResponse,
  SuperAdminDocumentControllerCleanUpDocumentsData,
  SuperAdminDocumentControllerCleanUpDocumentsResponse,
  SuperAdminDocumentControllerGetDocumentsData,
  SuperAdminDocumentControllerGetDocumentsResponse,
  SuperAdminDocumentControllerGetTiptapDatabaseBackfillPreviewData,
  SuperAdminDocumentControllerGetTiptapDatabaseBackfillPreviewResponse,
  SuperAdminDocumentControllerBackfillTiptapDatabaseData,
  SuperAdminDocumentControllerBackfillTiptapDatabaseResponse,
  GroupKitDocumentControllerGetDocumentsData,
  GroupKitDocumentControllerGetDocumentsResponse,
  GroupKitDocumentControllerCreateDocumentData,
  GroupKitDocumentControllerCreateDocumentResponse,
  GroupKitDocumentControllerDeleteDocumentData,
  GroupKitDocumentControllerDeleteDocumentResponse,
  GroupKitDocumentControllerGetDocumentData,
  GroupKitDocumentControllerGetDocumentResponse,
  GroupKitDocumentControllerUpdateDocumentData,
  GroupKitDocumentControllerUpdateDocumentResponse,
  GroupKitDocumentControllerExportDocumentData,
  GroupKitDocumentControllerExportDocumentResponse,
  GroupKitDocumentControllerGetDocumentAuthData,
  GroupKitDocumentControllerGetDocumentAuthResponse,
  GroupKitDocumentControllerUpdateOrderData,
  DocumentFileControllerAttachFileData,
  DocumentFileControllerAttachFileResponse,
  DocumentFileControllerGetDownloadUrlData,
  DocumentFileControllerGetDownloadUrlResponse,
  ExpertFolderControllerDissociateData,
  ExpertFolderControllerDissociateResponse,
  ExpertFolderControllerAssociateData,
  ExpertFolderControllerAssociateResponse,
  GroupKitExpertControllerGetExpertsData,
  GroupKitExpertControllerGetExpertsResponse,
  GroupKitExpertControllerCreateData,
  GroupKitExpertControllerCreateResponse,
  GroupKitExpertControllerGetRemovedExpertsData,
  GroupKitExpertControllerGetRemovedExpertsResponse,
  GroupKitExpertControllerGetSingleData,
  GroupKitExpertControllerGetSingleResponse,
  GroupKitExpertControllerPatchExpertData,
  GroupKitExpertControllerPatchExpertResponse,
  GroupKitExpertLinkControllerUnlinkData,
  GroupKitExpertLinkControllerLinkData,
  GroupExpertControllerGetAllData,
  GroupExpertControllerGetAllResponse,
  GroupExpertControllerGetExpertSkillsData,
  GroupExpertControllerGetExpertSkillsResponse,
  NangoWebhookControllerHandleWebhookData,
  NangoWebhookControllerHandleWebhookResponse,
  ExternalFileControllerBrowseFilesData,
  ExternalFileControllerBrowseFilesResponse,
  ExternalFileControllerAddExternalFileData,
  ExternalFileControllerAddExternalFileResponse,
  GroupKitFolderExternalFileControllerLinkExternalFileData,
  GroupKitFolderExternalFileControllerLinkExternalFileResponse,
  GroupKitFolderExternalFileControllerLinkExternalFilesBatchData,
  GroupKitFolderExternalFileControllerLinkExternalFilesBatchResponse,
  GroupKitExternalFolderControllerLinkExternalFolderData,
  GroupKitExternalFolderControllerLinkExternalFolderResponse,
  FileControllerGetFilesData,
  FileControllerGetFilesResponse,
  FileControllerCreateFileData,
  FileControllerCreateFileResponse,
  FileControllerDeleteFileData,
  FileControllerDeleteFileResponse,
  FileControllerGetFileData,
  FileControllerGetFileResponse,
  FileControllerUpdateFileData,
  FileControllerUpdateFileResponse,
  FileControllerReplaceFileData,
  FileControllerReplaceFileResponse,
  FileControllerConfirmFileUploadData,
  FileControllerConfirmFileUploadResponse,
  FileControllerParseFileData,
  FileControllerParseFileResponse,
  FileControllerGetDownloadUrlData,
  FileControllerGetDownloadUrlResponse,
  FileControllerGetRagSummaryData,
  FileControllerGetRagSummaryResponse,
  FileControllerGetMarkdownData,
  FileControllerGetMarkdownResponse,
  FileControllerGetParsingProgressData,
  FileControllerGetParsingProgressResponse,
  FileControllerAddToKnowledgeData,
  FileControllerAddToKnowledgeResponse,
  FileControllerTimeoutStaleFileParsesData,
  FileControllerTimeoutStaleFileParsesResponse,
  FileControllerCleanupData,
  FileControllerCleanupResponse,
  LibraryFileControllerConfirmFileUploadData,
  LibraryFileControllerConfirmFileUploadResponse,
  FolderControllerGetFoldersData,
  FolderControllerGetFoldersResponse,
  GroupFolderControllerGetAllData,
  GroupFolderControllerGetAllResponse,
  GroupKitFolderControllerGetAllData,
  GroupKitFolderControllerGetAllResponse,
  GroupKitFolderControllerCreateData,
  GroupKitFolderControllerCreateResponse,
  GroupKitFolderControllerDeleteData,
  GroupKitFolderControllerDeleteResponse,
  GroupKitFolderControllerGetFolderData,
  GroupKitFolderControllerGetFolderResponse,
  GroupKitFolderControllerUpdateData,
  GroupKitFolderControllerUpdateResponse,
  GroupKitFolderControllerSyncData,
  GroupKitFolderLinkControllerUnlinkData,
  GroupKitFolderLinkControllerLinkData,
  KitFolderControllerGetFolderData,
  KitFolderControllerGetFolderResponse,
  GrantControllerRevokeData,
  GrantControllerRevokeResponse,
  GrantControllerListData,
  GrantControllerListResponse,
  GrantControllerUpsertData,
  GrantControllerUpsertResponse,
  GrantControllerTransferOwnerData,
  GrantControllerTransferOwnerResponse,
  GrantControllerSetPublishedData,
  GrantControllerSetPublishedResponse,
  JobControllerCheckResearchesStatusData,
  JobControllerCheckResearchesStatusResponse,
  JobControllerCreateJobData,
  JobControllerCreateJobResponse,
  JobControllerDeleteJobData,
  JobControllerDeleteJobResponse,
  GroupKitControllerGetKitsData,
  GroupKitControllerGetKitsResponse,
  GroupKitControllerCreateKitData,
  GroupKitControllerCreateKitResponse,
  GroupKitControllerDeleteKitData,
  GroupKitControllerGetKitData,
  GroupKitControllerGetKitResponse,
  GroupKitControllerUpdateKitData,
  GroupKitControllerUpdateKitResponse,
  GroupKitControllerUpsertDefaultRepositoryKitData,
  GroupKitControllerUpsertDefaultRepositoryKitResponse,
  GroupKitControllerDeletionPreviewData,
  GroupKitControllerDeletionPreviewResponse,
  GroupKitControllerExportKitBundleData,
  GroupKitControllerExportKitBundleResponse,
  KitControllerGetAllData,
  KitControllerGetAllResponse,
  KitCollectionControllerUnlinkData,
  KitCollectionControllerLinkData,
  GroupKitLibraryImportControllerImportMeetingsData,
  GroupKitLibraryImportControllerImportMeetingsResponse,
  OrganizationControllerListData,
  OrganizationControllerListResponse,
  OrganizationControllerCreateData,
  OrganizationControllerCreateResponse,
  OrganizationControllerRenameData,
  OrganizationControllerRenameResponse,
  OrganizationControllerLookupUserData,
  OrganizationControllerLookupUserResponse,
  OrganizationControllerListMembersData,
  OrganizationControllerListMembersResponse,
  OrganizationControllerInviteMemberData,
  OrganizationControllerInviteMemberResponse,
  OrganizationControllerRemoveMemberData,
  OrganizationControllerRemoveMemberResponse,
  OrganizationControllerSetMemberRoleData,
  OrganizationControllerSetMemberRoleResponse,
  GroupKitExpertPerspectiveControllerGetManyData,
  GroupKitExpertPerspectiveControllerGetManyResponse,
  GroupKitExpertPerspectiveControllerCreateData,
  GroupKitExpertPerspectiveControllerCreateResponse,
  GroupKitExpertPerspectiveControllerDeleteData,
  GroupKitExpertPerspectiveControllerDeleteResponse,
  GroupKitExpertPerspectiveControllerGetOneData,
  GroupKitExpertPerspectiveControllerGetOneResponse,
  GroupKitExpertPerspectiveControllerUpdateData,
  GroupKitExpertPerspectiveControllerUpdateResponse,
  GroupKitResearchControllerGetAllResearchData,
  GroupKitResearchControllerGetAllResearchResponse,
  GroupKitResearchControllerCreateResearchData,
  GroupKitResearchControllerCreateResearchResponse,
  GroupKitResearchControllerCancelResearchData,
  GroupKitResearchControllerCancelResearchResponse,
  GroupKitResearchControllerGetResearchStatusData,
  GroupKitResearchControllerGetResearchStatusResponse,
  GroupKitResearchControllerDeleteResearchData,
  GroupKitResearchControllerDeleteResearchResponse,
  SalthubClientControllerGetSalthubClientsData,
  SalthubClientControllerGetSalthubClientsResponse,
  GroupScriptControllerGetAllData,
  GroupScriptControllerGetAllResponse,
  GroupScriptControllerCreateData,
  GroupScriptControllerCreateResponse,
  GroupScriptControllerDeleteScriptData,
  GroupScriptControllerGetSingleData,
  GroupScriptControllerGetSingleResponse,
  GroupScriptControllerPatchScriptData,
  GroupScriptControllerPatchScriptResponse,
  SettingsControllerGetAllSettingsData,
  SettingsControllerGetAllSettingsResponse,
  SettingsControllerSetSettingData,
  OrganizationSettingsControllerGetOrganizationSettingsData,
  OrganizationSettingsControllerGetOrganizationSettingsResponse,
  OrganizationSettingsControllerSetOrganizationSettingData,
  GroupKitExpertSkillControllerGetExpertSkillsData,
  GroupKitExpertSkillControllerGetExpertSkillsResponse,
  GroupKitExpertSkillControllerDissociateSkillFromExpertData,
  GroupKitExpertSkillControllerAssociateSkillWithExpertData,
  GroupKitSkillControllerGetAllData,
  GroupKitSkillControllerGetAllResponse,
  GroupKitSkillControllerCreateData,
  GroupKitSkillControllerCreateResponse,
  GroupKitSkillControllerDeleteSkillData,
  GroupKitSkillControllerGetSingleData,
  GroupKitSkillControllerGetSingleResponse,
  GroupKitSkillControllerPatchSkillData,
  GroupKitSkillControllerPatchSkillResponse,
  GroupKitSkillExpertControllerGetSkillExpertsData,
  GroupKitSkillExpertControllerGetSkillExpertsResponse,
  GroupKitSkillExpertControllerDissociateExpertFromSkillData,
  GroupKitSkillExpertControllerAssociateExpertWithSkillData,
  GroupKitSkillLinkControllerUnlinkData,
  GroupKitSkillLinkControllerLinkData,
  GroupSkillControllerGetAllData,
  GroupSkillControllerGetAllResponse,
  SuperAdminControllerMigrateVectorDatabaseMetadataData,
  SuperAdminControllerMigrateVectorDatabaseMetadataResponse,
  SuperAdminControllerBackfillOrganizationBucketCorsData,
  SuperAdminControllerBackfillOrganizationBucketCorsResponse,
  GroupKitTemplateControllerGetTemplatesData,
  GroupKitTemplateControllerGetTemplatesResponse,
  GroupKitTemplateControllerCreateTemplateData,
  GroupKitTemplateControllerCreateTemplateResponse,
  GroupKitTemplateControllerGetTemplateData,
  GroupKitTemplateControllerGetTemplateResponse,
  GroupKitTemplateControllerUpdateTemplateData,
  GroupKitTemplateControllerUpdateTemplateResponse,
  GroupKitTemplateLinkControllerUnlinkData,
  GroupKitTemplateLinkControllerLinkData,
  GroupTemplateControllerGetTemplatesData,
  GroupTemplateControllerGetTemplatesResponse,
  UsageControllerGetUsageData,
  UsageControllerGetUsageResponse,
  UserControllerGetUsersData,
  UserControllerGetUsersResponse,
  UserControllerCreateUserData,
  UserControllerCreateUserResponse,
  UserControllerDeleteUserData,
  UserControllerGetUserData,
  UserControllerGetUserResponse,
  UserControllerUpdateUserData,
  UserControllerUpdateUserResponse,
  UserControllerImpersonateData,
  UserControllerImpersonateResponse,
  UserControllerTestEmailData,
  GroupUserControllerGetCurrentUserData,
  GroupUserControllerGetCurrentUserResponse,
  GroupUserControllerGetUsersData,
  GroupUserControllerGetUsersResponse,
  GroupUserControllerCreateUserData,
  GroupUserControllerCreateUserResponse,
  GroupUserControllerDeleteUserData,
  GroupUserControllerDeleteUserResponse,
  GroupUserControllerUpdateUserData,
  GroupControllerGetGroupsData,
  GroupControllerGetGroupsResponse,
  GroupControllerCreateGroupData,
  GroupControllerCreateGroupResponse,
  GroupControllerGetShareTargetsData,
  GroupControllerGetShareTargetsResponse,
  GroupControllerDeleteGroupData,
  GroupControllerGetGroupData,
  GroupControllerGetGroupResponse,
  GroupControllerUpdateGroupData,
  GroupControllerGetGroupModelProfilesData,
  GroupControllerGetGroupModelProfilesResponse,
  GroupUserLinkControllerUnlinkUserData,
  GroupUserLinkControllerUnlinkUserResponse,
  GroupUserLinkControllerLinkUserData,
  GroupUserLinkControllerLinkUserResponse,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Check if service is ready to serve.
 */
export const healthControllerGetReadiness = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthControllerGetReadinessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthControllerGetReadinessResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/health/ready",
    ...options,
  });
};

/**
 * Check if service is alive.
 */
export const healthControllerGetLiveness = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthControllerGetLivenessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthControllerGetLivenessResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/health/live",
    ...options,
  });
};

/**
 * Forces teapot error.
 */
export const healthControllerGetCoffee = <ThrowOnError extends boolean = false>(
  options?: Options<HealthControllerGetCoffeeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    unknown,
    HealthControllerGetCoffeeError,
    ThrowOnError
  >({
    url: "/api/v2/health/coffee",
    ...options,
  });
};

/**
 * Forces unhandled error.
 */
export const healthControllerGetUnhandledError = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthControllerGetUnhandledErrorData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    unknown,
    HealthControllerGetUnhandledErrorError,
    ThrowOnError
  >({
    url: "/api/v2/health/unhandled-error",
    ...options,
  });
};

export const assignmentControllerGetGroupAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssignmentControllerGetGroupAssignmentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AssignmentControllerGetGroupAssignmentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/assignments",
    ...options,
  });
};

export const assignmentControllerGetUserAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssignmentControllerGetUserAssignmentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AssignmentControllerGetUserAssignmentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/assignments/users/{userUuid}",
    ...options,
  });
};

export const assignmentControllerUnassignUsersFromKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssignmentControllerUnassignUsersFromKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/assignments/kits/{kitUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const assignmentControllerGetKitAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssignmentControllerGetKitAssignmentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AssignmentControllerGetKitAssignmentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/assignments/kits/{kitUuid}",
    ...options,
  });
};

export const assignmentControllerAssignUsersToKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssignmentControllerAssignUsersToKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AssignmentControllerAssignUsersToKitResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/assignments/kits/{kitUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const assignmentControllerReassignKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AssignmentControllerReassignKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AssignmentControllerReassignKitResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/assignments/kits/{kitUuid}/reassign",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const authControllerGetAuthDetails = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AuthControllerGetAuthDetailsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AuthControllerGetAuthDetailsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/auth",
    ...options,
  });
};

/**
 * Detach a library file from a chat
 */
export const chatLibraryFileControllerDetachFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChatLibraryFileControllerDetachFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    ChatLibraryFileControllerDetachFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/chats/{chatUuid}/library-files/{fileUuid}",
    ...options,
  });
};

/**
 * Attach a library file to a chat
 */
export const chatLibraryFileControllerAttachFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChatLibraryFileControllerAttachFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ChatLibraryFileControllerAttachFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/chats/{chatUuid}/library-files/{fileUuid}",
    ...options,
  });
};

export const groupKitChatControllerGetChats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerGetChatsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitChatControllerGetChatsResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats",
    ...options,
  });
};

export const groupKitChatControllerCreateChat = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerCreateChatData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitChatControllerCreateChatResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitChatControllerDeleteChat = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerDeleteChatData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupKitChatControllerDeleteChatResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}",
    ...options,
  });
};

export const groupKitChatControllerGetChat = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerGetChatData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitChatControllerGetChatResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}",
    ...options,
  });
};

export const groupKitChatControllerUpdateChat = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerUpdateChatData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitChatControllerUpdateChatResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitChatControllerGetMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerGetMessagesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitChatControllerGetMessagesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}/messages",
    ...options,
  });
};

export const groupKitChatControllerDeleteMessage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitChatControllerDeleteMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupKitChatControllerDeleteMessageResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/chats/{chatUuid}/messages/{messageUuid}",
    ...options,
  });
};

/**
 * List connectors for the current user
 */
export const groupConnectorControllerListConnectors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupConnectorControllerListConnectorsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupConnectorControllerListConnectorsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/connectors",
    ...options,
  });
};

/**
 * Delete a connector
 * Hard-deletes the connection record. Data already imported through this connector is retained.
 */
export const groupConnectorControllerDeleteConnector = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupConnectorControllerDeleteConnectorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupConnectorControllerDeleteConnectorResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/connectors/{connectorUuid}",
    ...options,
  });
};

/**
 * Rename a connector
 */
export const groupConnectorControllerUpdateConnector = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupConnectorControllerUpdateConnectorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupConnectorControllerUpdateConnectorResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/connectors/{connectorUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create a Nango session token for connector OAuth
 * Returns a short-lived token for the Nango frontend SDK. Fireflies is the first supported provider.
 */
export const groupConnectorControllerCreateSessionToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupConnectorControllerCreateSessionTokenData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupConnectorControllerCreateSessionTokenResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/connectors/session-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Activate a connector after Nango OAuth
 * Creates or updates the connector record after the user completes OAuth in the Nango popup.
 */
export const groupConnectorControllerActivateConnector = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupConnectorControllerActivateConnectorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupConnectorControllerActivateConnectorResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/connectors/activate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * List meetings from a meeting-type connector
 */
export const groupMeetingControllerListMeetings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupMeetingControllerListMeetingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupMeetingControllerListMeetingsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/meetings",
    ...options,
  });
};

/**
 * Preview a meeting summary before import
 */
export const groupMeetingControllerGetMeetingPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupMeetingControllerGetMeetingPreviewData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupMeetingControllerGetMeetingPreviewResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/meetings/{meetingId}/preview",
    ...options,
  });
};

export const externalConnectionControllerCreateSessionToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerCreateSessionTokenData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    ExternalConnectionControllerCreateSessionTokenResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/create-session-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const externalConnectionControllerCreatePendingConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerCreatePendingConnectionData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    ExternalConnectionControllerCreatePendingConnectionResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/create-pending",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const externalConnectionControllerActivateConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerActivateConnectionData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    ExternalConnectionControllerActivateConnectionResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/activate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const externalConnectionControllerGetGroupConnections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerGetGroupConnectionsData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalConnectionControllerGetGroupConnectionsResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/group/{groupUuid}",
    ...options,
  });
};

export const externalConnectionControllerGetUserConnections = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExternalConnectionControllerGetUserConnectionsData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? _heyApiClient).get<
    ExternalConnectionControllerGetUserConnectionsResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/user",
    ...options,
  });
};

export const externalConnectionControllerListSharePointSites = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerListSharePointSitesData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalConnectionControllerListSharePointSitesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}/sharepoint/sites",
    ...options,
  });
};

export const externalConnectionControllerListSharePointDrives = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerListSharePointDrivesData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalConnectionControllerListSharePointDrivesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}/sharepoint/sites/{siteId}/drives",
    ...options,
  });
};

export const externalConnectionControllerGetSharePointMyDrive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerGetSharePointMyDriveData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalConnectionControllerGetSharePointMyDriveResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}/sharepoint/my-drive",
    ...options,
  });
};

export const externalConnectionControllerGetSharePointDriveRoot = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerGetSharePointDriveRootData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalConnectionControllerGetSharePointDriveRootResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}/sharepoint/drives/{driveId}/root",
    ...options,
  });
};

export const externalConnectionControllerDeleteConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExternalConnectionControllerDeleteConnectionData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).delete<
    ExternalConnectionControllerDeleteConnectionResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}",
    ...options,
  });
};

export const externalConnectionControllerGetConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalConnectionControllerGetConnectionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalConnectionControllerGetConnectionResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}",
    ...options,
  });
};

export const externalConnectionControllerTriggerSync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalConnectionControllerTriggerSyncData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ExternalConnectionControllerTriggerSyncResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-connections/{connectionUuid}/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const customPromptControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CustomPromptControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CustomPromptControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/custom-prompts",
    ...options,
  });
};

export const customPromptControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CustomPromptControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CustomPromptControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/custom-prompts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const customPromptControllerDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CustomPromptControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/custom-prompts/{customPromptUuid}",
    ...options,
  });
};

export const customPromptControllerGetOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CustomPromptControllerGetOneData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CustomPromptControllerGetOneResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/custom-prompts/{customPromptUuid}",
    ...options,
  });
};

export const customPromptControllerPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CustomPromptControllerPatchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    CustomPromptControllerPatchResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/custom-prompts/{customPromptUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const superAdminDocumentControllerCleanUpDocuments = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SuperAdminDocumentControllerCleanUpDocumentsData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? _heyApiClient).delete<
    SuperAdminDocumentControllerCleanUpDocumentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/super-admin/tiptap-clean-up",
    ...options,
  });
};

export const superAdminDocumentControllerGetDocuments = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SuperAdminDocumentControllerGetDocumentsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SuperAdminDocumentControllerGetDocumentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/super-admin/tiptap-clean-up",
    ...options,
  });
};

export const superAdminDocumentControllerGetTiptapDatabaseBackfillPreview = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SuperAdminDocumentControllerGetTiptapDatabaseBackfillPreviewData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? _heyApiClient).get<
    SuperAdminDocumentControllerGetTiptapDatabaseBackfillPreviewResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/super-admin/tiptap-backfill-database",
    ...options,
  });
};

export const superAdminDocumentControllerBackfillTiptapDatabase = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SuperAdminDocumentControllerBackfillTiptapDatabaseData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? _heyApiClient).post<
    SuperAdminDocumentControllerBackfillTiptapDatabaseResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/super-admin/tiptap-backfill-database",
    ...options,
  });
};

export const groupKitDocumentControllerGetDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerGetDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitDocumentControllerGetDocumentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents",
    ...options,
  });
};

export const groupKitDocumentControllerCreateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerCreateDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitDocumentControllerCreateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitDocumentControllerDeleteDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerDeleteDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupKitDocumentControllerDeleteDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents/{documentUuid}",
    ...options,
  });
};

export const groupKitDocumentControllerGetDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerGetDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitDocumentControllerGetDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents/{documentUuid}",
    ...options,
  });
};

export const groupKitDocumentControllerUpdateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerUpdateDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitDocumentControllerUpdateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents/{documentUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitDocumentControllerExportDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerExportDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitDocumentControllerExportDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents/{documentUuid}/export",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitDocumentControllerGetDocumentAuth = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerGetDocumentAuthData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitDocumentControllerGetDocumentAuthResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents/{documentUuid}/auth",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitDocumentControllerUpdateOrder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitDocumentControllerUpdateOrderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/documents/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const documentFileControllerAttachFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DocumentFileControllerAttachFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DocumentFileControllerAttachFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/document/{documentUuid}/file/{fileUuid}",
    ...options,
  });
};

export const documentFileControllerGetDownloadUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DocumentFileControllerGetDownloadUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DocumentFileControllerGetDownloadUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/document/{documentUuid}/file/{fileUuid}/download",
    ...options,
  });
};

export const expertFolderControllerDissociate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExpertFolderControllerDissociateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    ExpertFolderControllerDissociateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/expert-folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const expertFolderControllerAssociate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExpertFolderControllerAssociateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ExpertFolderControllerAssociateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/expert-folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExpertControllerGetExperts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertControllerGetExpertsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitExpertControllerGetExpertsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts",
    ...options,
  });
};

export const groupKitExpertControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitExpertControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExpertControllerGetRemovedExperts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertControllerGetRemovedExpertsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitExpertControllerGetRemovedExpertsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/removed",
    ...options,
  });
};

export const groupKitExpertControllerGetSingle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertControllerGetSingleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitExpertControllerGetSingleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}",
    ...options,
  });
};

export const groupKitExpertControllerPatchExpert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertControllerPatchExpertData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitExpertControllerPatchExpertResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExpertLinkControllerUnlink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertLinkControllerUnlinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/link",
    ...options,
  });
};

export const groupKitExpertLinkControllerLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertLinkControllerLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/link",
      ...options,
    },
  );
};

export const groupExpertControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupExpertControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupExpertControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/experts",
    ...options,
  });
};

export const groupExpertControllerGetExpertSkills = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupExpertControllerGetExpertSkillsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupExpertControllerGetExpertSkillsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/experts/{expertUuid}/skills",
    ...options,
  });
};

export const nangoWebhookControllerHandleWebhook = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NangoWebhookControllerHandleWebhookData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    NangoWebhookControllerHandleWebhookResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/webhooks/nango",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const externalFileControllerBrowseFiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalFileControllerBrowseFilesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ExternalFileControllerBrowseFilesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-files/browse/{connectionUuid}",
    ...options,
  });
};

export const externalFileControllerAddExternalFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExternalFileControllerAddExternalFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ExternalFileControllerAddExternalFileResponse,
    unknown,
    ThrowOnError
  >({
    url: "/api/v2/external-files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitFolderExternalFileControllerLinkExternalFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitFolderExternalFileControllerLinkExternalFileData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitFolderExternalFileControllerLinkExternalFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}/external-files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitFolderExternalFileControllerLinkExternalFilesBatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitFolderExternalFileControllerLinkExternalFilesBatchData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitFolderExternalFileControllerLinkExternalFilesBatchResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}/external-files/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExternalFolderControllerLinkExternalFolder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitExternalFolderControllerLinkExternalFolderData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitExternalFolderControllerLinkExternalFolderResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/external-folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const fileControllerGetFiles = <ThrowOnError extends boolean = false>(
  options?: Options<FileControllerGetFilesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    FileControllerGetFilesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files",
    ...options,
  });
};

export const fileControllerCreateFile = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerCreateFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FileControllerCreateFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete a file
 * Deletes a file from storage and removes all associated chunks from the RAG database
 */
export const fileControllerDeleteFile = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerDeleteFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    FileControllerDeleteFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}",
    ...options,
  });
};

export const fileControllerGetFile = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerGetFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileControllerGetFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}",
    ...options,
  });
};

export const fileControllerUpdateFile = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerUpdateFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    FileControllerUpdateFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const fileControllerReplaceFile = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerReplaceFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    FileControllerReplaceFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}",
    ...options,
  });
};

/**
 * Confirm the file is uploaded.
 * After user uploads file to GCS, this endpoint is called for confirming the file is uploaded. This will trigger parsing.
 */
export const fileControllerConfirmFileUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerConfirmFileUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    FileControllerConfirmFileUploadResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/confirm-upload",
    ...options,
  });
};

export const fileControllerParseFile = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerParseFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    FileControllerParseFileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/parse",
    ...options,
  });
};

/**
 * Get a download URL for a file
 * Returns a temporary signed URL for downloading the file content
 */
export const fileControllerGetDownloadUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerGetDownloadUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileControllerGetDownloadUrlResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/download",
    ...options,
  });
};

export const fileControllerGetRagSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerGetRagSummaryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileControllerGetRagSummaryResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/rag-summary",
    ...options,
  });
};

export const fileControllerGetMarkdown = <ThrowOnError extends boolean = false>(
  options: Options<FileControllerGetMarkdownData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileControllerGetMarkdownResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/markdown",
    ...options,
  });
};

export const fileControllerGetParsingProgress = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerGetParsingProgressData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FileControllerGetParsingProgressResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/progress",
    ...options,
  });
};

/**
 * Copy a library file into a knowledge folder
 * Copies the library file into the specified knowledge folder and queues it for parsing.
 */
export const fileControllerAddToKnowledge = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FileControllerAddToKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FileControllerAddToKnowledgeResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/{fileUuid}/add-to-knowledge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const fileControllerTimeoutStaleFileParses = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<FileControllerTimeoutStaleFileParsesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    FileControllerTimeoutStaleFileParsesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/parse-timeout",
    ...options,
  });
};

/**
 * Clean up expired Claude file references
 * Deletes Claude Files API entries for library files uploaded more than 48 hours ago and clears the references in the database. Protected by BotGuard.
 */
export const fileControllerCleanup = <ThrowOnError extends boolean = false>(
  options?: Options<FileControllerCleanupData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    FileControllerCleanupResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/files/cleanup",
    ...options,
  });
};

/**
 * Confirm the library file is uploaded.
 * Confirms an authenticated user's library upload after uploading to storage. Starts parsing only when the file is also knowledge.
 */
export const libraryFileControllerConfirmFileUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LibraryFileControllerConfirmFileUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LibraryFileControllerConfirmFileUploadResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/library-files/{fileUuid}/confirm-upload",
    ...options,
  });
};

export const folderControllerGetFolders = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FolderControllerGetFoldersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    FolderControllerGetFoldersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/folders",
    ...options,
  });
};

export const groupFolderControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupFolderControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupFolderControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/folders",
    ...options,
  });
};

export const groupKitFolderControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitFolderControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders",
    ...options,
  });
};

export const groupKitFolderControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitFolderControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitFolderControllerDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupKitFolderControllerDeleteResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}",
    ...options,
  });
};

export const groupKitFolderControllerGetFolder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderControllerGetFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitFolderControllerGetFolderResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}",
    ...options,
  });
};

export const groupKitFolderControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitFolderControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitFolderControllerSync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderControllerSyncData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}/sync",
    ...options,
  });
};

export const groupKitFolderLinkControllerUnlink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderLinkControllerUnlinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}/link",
    ...options,
  });
};

export const groupKitFolderLinkControllerLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitFolderLinkControllerLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/folders/{folderUuid}/link",
      ...options,
    },
  );
};

export const kitFolderControllerGetFolder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KitFolderControllerGetFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    KitFolderControllerGetFolderResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/kits/{kitUuid}/folders/{folderUuid}",
    ...options,
  });
};

export const grantControllerRevoke = <ThrowOnError extends boolean = false>(
  options: Options<GrantControllerRevokeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GrantControllerRevokeResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/grants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const grantControllerList = <ThrowOnError extends boolean = false>(
  options?: Options<GrantControllerListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GrantControllerListResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/grants",
    ...options,
  });
};

export const grantControllerUpsert = <ThrowOnError extends boolean = false>(
  options: Options<GrantControllerUpsertData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GrantControllerUpsertResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/grants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const grantControllerTransferOwner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GrantControllerTransferOwnerData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GrantControllerTransferOwnerResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/grants/transfer-owner",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const grantControllerSetPublished = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GrantControllerSetPublishedData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GrantControllerSetPublishedResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/grants/published",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const jobControllerCheckResearchesStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<JobControllerCheckResearchesStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    JobControllerCheckResearchesStatusResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/jobs/update",
    ...options,
  });
};

export const jobControllerCreateJob = <ThrowOnError extends boolean = false>(
  options: Options<JobControllerCreateJobData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    JobControllerCreateJobResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/jobs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const jobControllerDeleteJob = <ThrowOnError extends boolean = false>(
  options: Options<JobControllerDeleteJobData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    JobControllerDeleteJobResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/jobs/{jobId}",
    ...options,
  });
};

export const groupKitControllerGetKits = <ThrowOnError extends boolean = false>(
  options: Options<GroupKitControllerGetKitsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitControllerGetKitsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits",
    ...options,
  });
};

export const groupKitControllerCreateKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitControllerCreateKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitControllerCreateKitResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitControllerDeleteKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitControllerDeleteKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}",
    ...options,
  });
};

export const groupKitControllerGetKit = <ThrowOnError extends boolean = false>(
  options: Options<GroupKitControllerGetKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitControllerGetKitResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}",
    ...options,
  });
};

export const groupKitControllerUpdateKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitControllerUpdateKitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitControllerUpdateKitResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitControllerUpsertDefaultRepositoryKit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitControllerUpsertDefaultRepositoryKitData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).put<
    GroupKitControllerUpsertDefaultRepositoryKitResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/default-repository-kit",
    ...options,
  });
};

export const groupKitControllerDeletionPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitControllerDeletionPreviewData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitControllerDeletionPreviewResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/deletion-preview",
    ...options,
  });
};

export const groupKitControllerExportKitBundle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitControllerExportKitBundleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitControllerExportKitBundleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/export",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const kitControllerGetAll = <ThrowOnError extends boolean = false>(
  options: Options<KitControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    KitControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/kits",
    ...options,
  });
};

export const kitCollectionControllerUnlink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KitCollectionControllerUnlinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/kit-collections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const kitCollectionControllerLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KitCollectionControllerLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/kit-collections",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );
};

/**
 * Import meetings from a connector into the project library
 * Fetches transcript and summary from the connector and creates library files for each meeting.
 */
export const groupKitLibraryImportControllerImportMeetings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitLibraryImportControllerImportMeetingsData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitLibraryImportControllerImportMeetingsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/library/import",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const organizationControllerList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OrganizationControllerListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OrganizationControllerListResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations",
    ...options,
  });
};

export const organizationControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const organizationControllerRename = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerRenameData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    OrganizationControllerRenameResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const organizationControllerLookupUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerLookupUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OrganizationControllerLookupUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/user-lookup",
    ...options,
  });
};

export const organizationControllerListMembers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerListMembersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OrganizationControllerListMembersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/members",
    ...options,
  });
};

export const organizationControllerInviteMember = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerInviteMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerInviteMemberResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const organizationControllerRemoveMember = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerRemoveMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    OrganizationControllerRemoveMemberResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/members/{userUuid}",
    ...options,
  });
};

export const organizationControllerSetMemberRole = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationControllerSetMemberRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    OrganizationControllerSetMemberRoleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/members/{userUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExpertPerspectiveControllerGetMany = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitExpertPerspectiveControllerGetManyData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitExpertPerspectiveControllerGetManyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/perspectives",
    ...options,
  });
};

export const groupKitExpertPerspectiveControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertPerspectiveControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitExpertPerspectiveControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/perspectives",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExpertPerspectiveControllerDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertPerspectiveControllerDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupKitExpertPerspectiveControllerDeleteResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/perspectives/{perspectiveUuid}",
    ...options,
  });
};

export const groupKitExpertPerspectiveControllerGetOne = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertPerspectiveControllerGetOneData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitExpertPerspectiveControllerGetOneResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/perspectives/{perspectiveUuid}",
    ...options,
  });
};

export const groupKitExpertPerspectiveControllerUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitExpertPerspectiveControllerUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitExpertPerspectiveControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/perspectives/{perspectiveUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitResearchControllerGetAllResearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitResearchControllerGetAllResearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitResearchControllerGetAllResearchResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/researches",
    ...options,
  });
};

export const groupKitResearchControllerCreateResearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitResearchControllerCreateResearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitResearchControllerCreateResearchResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/researches",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitResearchControllerCancelResearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitResearchControllerCancelResearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitResearchControllerCancelResearchResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/researches/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitResearchControllerGetResearchStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitResearchControllerGetResearchStatusData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitResearchControllerGetResearchStatusResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/researches/{researchUuid}/status",
    ...options,
  });
};

export const groupKitResearchControllerDeleteResearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitResearchControllerDeleteResearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupKitResearchControllerDeleteResearchResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/researches/{researchId}",
    ...options,
  });
};

export const salthubClientControllerGetSalthubClients = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SalthubClientControllerGetSalthubClientsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SalthubClientControllerGetSalthubClientsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/salthub-clients",
    ...options,
  });
};

export const groupScriptControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupScriptControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupScriptControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/scripts",
    ...options,
  });
};

export const groupScriptControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupScriptControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupScriptControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/scripts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupScriptControllerDeleteScript = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupScriptControllerDeleteScriptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/scripts/{scriptUuid}",
    ...options,
  });
};

export const groupScriptControllerGetSingle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupScriptControllerGetSingleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupScriptControllerGetSingleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/scripts/{scriptUuid}",
    ...options,
  });
};

export const groupScriptControllerPatchScript = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupScriptControllerPatchScriptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupScriptControllerPatchScriptResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/scripts/{scriptUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const settingsControllerGetAllSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SettingsControllerGetAllSettingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SettingsControllerGetAllSettingsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/settings",
    ...options,
  });
};

export const settingsControllerSetSetting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SettingsControllerSetSettingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const organizationSettingsControllerGetOrganizationSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationSettingsControllerGetOrganizationSettingsData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    OrganizationSettingsControllerGetOrganizationSettingsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/settings",
    ...options,
  });
};

export const organizationSettingsControllerSetOrganizationSetting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationSettingsControllerSetOrganizationSettingData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/organizations/{organizationUuid}/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitExpertSkillControllerGetExpertSkills = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitExpertSkillControllerGetExpertSkillsData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitExpertSkillControllerGetExpertSkillsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/skills",
    ...options,
  });
};

export const groupKitExpertSkillControllerDissociateSkillFromExpert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitExpertSkillControllerDissociateSkillFromExpertData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/skills/{skillUuid}",
    ...options,
  });
};

export const groupKitExpertSkillControllerAssociateSkillWithExpert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitExpertSkillControllerAssociateSkillWithExpertData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/experts/{expertUuid}/skills/{skillUuid}",
      ...options,
    },
  );
};

export const groupKitSkillControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitSkillControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills",
    ...options,
  });
};

export const groupKitSkillControllerCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillControllerCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitSkillControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitSkillControllerDeleteSkill = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillControllerDeleteSkillData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}",
    ...options,
  });
};

export const groupKitSkillControllerGetSingle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillControllerGetSingleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitSkillControllerGetSingleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}",
    ...options,
  });
};

export const groupKitSkillControllerPatchSkill = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillControllerPatchSkillData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitSkillControllerPatchSkillResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitSkillExpertControllerGetSkillExperts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitSkillExpertControllerGetSkillExpertsData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitSkillExpertControllerGetSkillExpertsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}/experts",
    ...options,
  });
};

export const groupKitSkillExpertControllerDissociateExpertFromSkill = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitSkillExpertControllerDissociateExpertFromSkillData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}/experts/{expertUuid}",
    ...options,
  });
};

export const groupKitSkillExpertControllerAssociateExpertWithSkill = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GroupKitSkillExpertControllerAssociateExpertWithSkillData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}/experts/{expertUuid}",
      ...options,
    },
  );
};

export const groupKitSkillLinkControllerUnlink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillLinkControllerUnlinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}/link",
    ...options,
  });
};

export const groupKitSkillLinkControllerLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitSkillLinkControllerLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/skills/{skillUuid}/link",
      ...options,
    },
  );
};

export const groupSkillControllerGetAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupSkillControllerGetAllData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupSkillControllerGetAllResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/skills",
    ...options,
  });
};

export const superAdminControllerMigrateVectorDatabaseMetadata = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SuperAdminControllerMigrateVectorDatabaseMetadataData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? _heyApiClient).post<
    SuperAdminControllerMigrateVectorDatabaseMetadataResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/super-admin/migrate-vector-database-metadata",
    ...options,
  });
};

export const superAdminControllerBackfillOrganizationBucketCors = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SuperAdminControllerBackfillOrganizationBucketCorsData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? _heyApiClient).post<
    SuperAdminControllerBackfillOrganizationBucketCorsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/super-admin/backfill-organization-bucket-cors",
    ...options,
  });
};

export const groupKitTemplateControllerGetTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateControllerGetTemplatesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitTemplateControllerGetTemplatesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/templates",
    ...options,
  });
};

export const groupKitTemplateControllerCreateTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateControllerCreateTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupKitTemplateControllerCreateTemplateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitTemplateControllerGetTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateControllerGetTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupKitTemplateControllerGetTemplateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/templates/{templateUuid}",
    ...options,
  });
};

export const groupKitTemplateControllerUpdateTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateControllerUpdateTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    GroupKitTemplateControllerUpdateTemplateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/templates/{templateUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupKitTemplateLinkControllerUnlink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateLinkControllerUnlinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/templates/{templateUuid}/link",
    ...options,
  });
};

export const groupKitTemplateLinkControllerLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupKitTemplateLinkControllerLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/groups/{groupUuid}/kits/{kitUuid}/templates/{templateUuid}/link",
      ...options,
    },
  );
};

export const groupTemplateControllerGetTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupTemplateControllerGetTemplatesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupTemplateControllerGetTemplatesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/templates",
    ...options,
  });
};

export const usageControllerGetUsage = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetUsageData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsageControllerGetUsageResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/usage",
    ...options,
  });
};

export const userControllerGetUsers = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerGetUsersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UserControllerGetUsersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/users",
    ...options,
  });
};

export const userControllerCreateUser = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerCreateUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UserControllerCreateUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const userControllerDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerDeleteUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/users/{userUuid}",
    ...options,
  });
};

export const userControllerGetUser = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerGetUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    UserControllerGetUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/users/{userUuid}",
    ...options,
  });
};

export const userControllerUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerUpdateUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UserControllerUpdateUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/users/{userUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const userControllerImpersonate = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerImpersonateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UserControllerImpersonateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/users/{userUuid}/impersonate",
    ...options,
  });
};

export const userControllerTestEmail = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerTestEmailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/api/v2/users/{userUuid}/test-email",
      ...options,
    },
  );
};

export const groupUserControllerGetCurrentUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserControllerGetCurrentUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupUserControllerGetCurrentUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/users/me",
    ...options,
  });
};

export const groupUserControllerGetUsers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserControllerGetUsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupUserControllerGetUsersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/users",
    ...options,
  });
};

export const groupUserControllerCreateUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserControllerCreateUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupUserControllerCreateUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupUserControllerDeleteUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserControllerDeleteUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupUserControllerDeleteUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/users/{userUuid}",
    ...options,
  });
};

export const groupUserControllerUpdateUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserControllerUpdateUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/users/{userUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupControllerGetGroups = <ThrowOnError extends boolean = false>(
  options?: Options<GroupControllerGetGroupsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GroupControllerGetGroupsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups",
    ...options,
  });
};

export const groupControllerCreateGroup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupControllerCreateGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupControllerCreateGroupResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupControllerGetShareTargets = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GroupControllerGetShareTargetsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GroupControllerGetShareTargetsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/share-targets",
    ...options,
  });
};

export const groupControllerDeleteGroup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupControllerDeleteGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}",
    ...options,
  });
};

export const groupControllerGetGroup = <ThrowOnError extends boolean = false>(
  options: Options<GroupControllerGetGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupControllerGetGroupResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}",
    ...options,
  });
};

export const groupControllerUpdateGroup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupControllerUpdateGroupData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const groupControllerGetGroupModelProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupControllerGetGroupModelProfilesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GroupControllerGetGroupModelProfilesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/model-profiles",
    ...options,
  });
};

export const groupUserLinkControllerUnlinkUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserLinkControllerUnlinkUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    GroupUserLinkControllerUnlinkUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/user-links/{userUuid}",
    ...options,
  });
};

export const groupUserLinkControllerLinkUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GroupUserLinkControllerLinkUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GroupUserLinkControllerLinkUserResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/v2/groups/{groupUuid}/user-links/{userUuid}",
    ...options,
  });
};
